import api from "../../service/api";
import routes from "../../service/apiRoutes";

export const createReportUnauth = (data) => api.post(`${routes.createReportUnauth}`, data, {noauth: true})
